export const DEVELOPMENT_HOST = 'localhost:3000'
export const PARCEL_PERFORM_DOMAIN = 'parcelperform.com'
export const PLATO_LOGIN_TOKEN = 'F6#!RRTJm6@LPKdqVogpBFZeCuxbJKbg@aEZRsmfa4962!9GRS%b$HUtFw9qs7!VYyVxRaFVQNeKpAEY7o&KkL^WERb4BB#Zh3iRVa7c&N%m$TSfewFw%huDvwxb%EmF'
export const PROJECT_ID = 'pp-contentful'
export const HUBSPOT_PORTAL_ID = '2453247'
export const HUBSPOT_PORTAL_REGION = 'na1'
export const CONNECTING_TO_REDIS = 'Connecting to %cRe%cdi%cs'
export const CONNECTING_TO_CONTENTFUL = 'Connecting to %cCon%ctent%cful'
